/**
 * Troca de senha obrigatória: senha marcada para troca ou trocada há mais de seis meses. Contas
 * @coopercarga.com.br entram pela Microsoft e ficam de fora. Usada pelos guards de rota privada
 * (que mostram a UpdatePasswordPage) e pelo Flow Chat (que esconde o botão).
 */
export function mustChangePassword(
  {
    isCooperMail,
    isUserActive,
    isUserBlocked,
    authenticated,
    shouldUserChangePassword,
    lastPasswordUpdate,
  },
  now = new Date(),
) {
  // Preserva o dia exato; se o mês de destino for mais curto (overflow do
  // Date nativo, ex.: 31/ago - 6 meses "vazaria" para março), faz clamp
  // para o último dia do mês de destino em vez de sempre usar o dia 1.
  const sixMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());
  if (sixMonthsAgo.getDate() !== now.getDate()) {
    sixMonthsAgo.setDate(0);
  }
  const isLastUpdateOlderThanSixMonths = new Date(lastPasswordUpdate) < sixMonthsAgo;

  return (
    !isCooperMail &&
    isUserActive &&
    authenticated &&
    !isUserBlocked &&
    (shouldUserChangePassword || isLastUpdateOlderThanSixMonths)
  );
}
